import './DataTableV2EmptyState.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var dataTableV2EmptyStateCss = _7a468({defaultClassName:'_1nfdb040-2-0-1',variantClassNames:{fullSize:{true:'_1nfdb041-2-0-1'}},defaultVariants:{},compoundVariants:[]});